import { GroupBy } from 'containers/CarnetsDeNotes/CarnetDetails/types';
import { CarnetDeNotesPdfSettings } from 'containers/CarnetsDeNotes/types/carnetsDeNotes';

interface Props {
  lng: string;
  settings: CarnetDeNotesPdfSettings;
  groupBy: GroupBy;
}

export function buildCdnParams({ lng, settings, groupBy }: Props) {
  const params = new URLSearchParams({
    lng,
    groupby: groupBy,
    landscape: (settings.landscape || false).toString(),
    size: (settings.size || 14).toString(),
    bgColor: settings.bgColor || 'white',
    marginTop: (settings.marginTop ?? 6).toString(),
    marginBottom: (settings.marginBottom ?? 6).toString(),
    marginLeft: (settings.marginLeft ?? 6).toString(),
    marginRight: (settings.marginRight ?? 6).toString(),
  });

  if (settings.font) {
    params.set('font', settings.font);
  }

  return params;
}
